const createGroceryList = ({ el, store }, Vue, Store, Pubsub, Helper, Globals) => new Vue({
    el,
    delimiters: ['((', '))'],
    data: store,
    watch: {
        areIngredientsGrouped() {
            this.$emit('areIngredientsGrouped.changed', this.areIngredientsGrouped);
        }
    },
    computed: {
        filteredIngredients() {
            if (!this.filteredRecipeId) {
                return this.ingredients;
            }

            return this.ingredients.filter((ingredient) => {
                return String(ingredient.recipeId) === String(this.filteredRecipeId);
            });
        },
        filteredRecipe() {
            if (!this.filteredRecipeId || !this.filteredIngredients[0]) {
                return null;
            }

            return {
                id: this.filteredRecipeId,
                name: this.filteredIngredients[0].recipe
            };
        },
        stateRayonGroupedIngredients() {
            return Helper.groupByArray(this.filteredIngredients, 'rayon');
        }
    }
});

export default createGroceryList;
